// Kept free of imports: meeting-sip-region reads these at load time, and phone-actions sits in an
// import cycle with it, so defining them there crashed startup with "Cannot access before initialization".

export type SipProxy = { socketUrl: string; weight: number };

export const FALLBACK_SIP_PROXIES: SipProxy[] = [
    { socketUrl: 'wss://sipproxy5.telavox.se:443', weight: 1 },
    { socketUrl: 'wss://sipproxy6.telavox.se:443', weight: 1 },
    { socketUrl: 'wss://sipproxy7.telavox.se:443', weight: 1 },
];

export const FALLBACK_SIP_PROXIES_UAE: SipProxy[] = [
    { socketUrl: 'wss://sipproxy-pub-ae2.tvx.etisalat.ae:443', weight: 1 },
    { socketUrl: 'wss://sipproxy-pub-ae3.tvx.etisalat.ae:443', weight: 1 },
    { socketUrl: 'wss://sipproxy-pub-ae9.tvx.etisalat.ae:443', weight: 1 },
];

export const FALLBACK_SIP_PROXIES_UK: SipProxy[] = [
    { socketUrl: 'wss://sipproxy-uk1.telavox.co.uk:443', weight: 1 },
    { socketUrl: 'wss://sipproxy-uk2.telavox.co.uk:443', weight: 1 },
    { socketUrl: 'wss://sipproxy-uk3.telavox.co.uk:443', weight: 1 },
    { socketUrl: 'wss://sipproxy-uk4.telavox.co.uk:443', weight: 1 },
];
